import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { determineDeclension as declension, getLocalCurrencyStr } from '@beef/utils';
import { defineUrlIcon } from '@carnica/graphics';
import { FUB_COMMON_STATUS, MEMBERS_TEXT, dictionary, fubTexts } from "../constants";
export var getPeriodTextByDay = function getPeriodTextByDay(day) {
  return day > 29 ? dictionary.days[3] : "".concat(day > 1 ? day : '', " ").concat(declension(dictionary.days, day));
};
export var getTariffPrice = function getTariffPrice(price, periodDays) {
  var result = getLocalCurrencyStr(price);
  if (Number(periodDays) > 0) {
    return "".concat(result, "/").concat(getPeriodTextByDay(periodDays));
  }
  return result;
};
export var getFormattedCtn = function getFormattedCtn(ctn) {
  var isFttb = ctn[0] === '0' || ctn[0] === '8';
  if (isFttb) {
    return "".concat(ctn.replace(/^0?8(\d{1})(\d{3})(\d{2})(\d{2})$/, '08$1-$2-$3-$4'));
  }
  return "".concat(ctn.replace(/^(\d{3})(\d{3})(\d{2})(\d{1,2})$/, '+7 $1 $2 $3 $4'));
};
export var getTextVariantByCount = function getTextVariantByCount(count, variants) {
  if (count > 0) {
    if (count % 10 === 1 && count % 100 !== 11) {
      return "".concat(count, " ").concat(variants[0]);
    }
    if (count % 10 >= 2 && count % 10 <= 4 && (count % 100 < 10 || count % 100 >= 20)) {
      return "".concat(count, " ").concat(variants[1]);
    }
    return "".concat(count, " ").concat(variants[2]);
  }
  return '';
};
export var getBannerTitleSlaveGroup = function getBannerTitleSlaveGroup(count) {
  if (count === 1) {
    return fubTexts.membersBannerTitle.slave.single;
  }
  if (count > 1) {
    return fubTexts.membersBannerTitle.slave.multy;
  }
  return '';
};
export var getGroupTitleBlock = function getGroupTitleBlock(status, members, groups) {
  var titleBlock = {
    title: '',
    subTitle: ''
  };
  switch (status) {
    case FUB_COMMON_STATUS.AVAILABLE:
      titleBlock.title = fubTexts.membersBannerTitle.available;
      break;
    case FUB_COMMON_STATUS.MASTER:
      titleBlock.title = fubTexts.membersBannerTitle.master;
      titleBlock.subTitle = members > 0 ? "".concat(getTextVariantByCount(members, MEMBERS_TEXT)) : '';
      break;
    case FUB_COMMON_STATUS.SLAVE:
      titleBlock.title = getBannerTitleSlaveGroup(groups);
      break;
    default:
      break;
  }
  return titleBlock;
};
export var getUniqTypeList = function getUniqTypeList(list) {
  var _Object$values;
  var values = (_Object$values = Object.values(list)) === null || _Object$values === void 0 ? void 0 : _Object$values.flat();
  return _toConsumableArray(new Set(values === null || values === void 0 ? void 0 : values.map(function (item) {
    return item === null || item === void 0 ? void 0 : item.type;
  })));
};
export var getItems = function getItems(members) {
  return members === null || members === void 0 ? void 0 : members.map(function (item) {
    var _item$type;
    var key = item === null || item === void 0 ? void 0 : (_item$type = item.type) === null || _item$type === void 0 ? void 0 : _item$type.toLowerCase();
    return {
      icon: defineUrlIcon({
        url: fubTexts.avatar[key],
        multiColor: false,
        defaultSize: 30,
        ratio: 1
      })
    };
  });
};
export var getGroupAppModalTitle = function getGroupAppModalTitle(status) {
  if (status === FUB_COMMON_STATUS.AVAILABLE) {
    return fubTexts.appModal.title.available;
  }
  return fubTexts.appModal.title.default;
};
export var getIsStatusEnabled = function getIsStatusEnabled(status) {
  return [FUB_COMMON_STATUS.AVAILABLE, FUB_COMMON_STATUS.MASTER, FUB_COMMON_STATUS.SLAVE].includes(status);
};